import { render, staticRenderFns } from "./BasicInformations.vue?vue&type=template&id=a8a125d8"
import script from "./BasicInformations.vue?vue&type=script&lang=js"
export * from "./BasicInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports